@for (file of files; track file) {
  <div class="operation-file" (click)="onfileClick(file)">
    @if (checkbox) {
      <div class="checkbox-container">
        @if (file.fileId) {
          <oui-checkbox
            class="file-checkbox"
            [checked]="isIncluded(file.id)"
            (checkedChange)="toggleFileSelection(file.id)"
          (click)="$event.stopPropagation()"></oui-checkbox>
        }
      </div>
    }
    <div class="denomination">
      <div class="file-libelle body-2">
        {{
        getFileLabel(file)
        }}
      </div>
      <div class="file-nature caption">
        {{ getSubLabel(file) }}
      </div>
    </div>
    <div class="file-name caption">
      {{ file.metadata?.fileName }}
    </div>
    @if (isStatusDisplayed(file)) {
      <div class="status-container">
        <app-file-statut-tag class="file-status" [file]="file"></app-file-statut-tag>
      </div>
    }
  </div>
}
